//
// # Validation Utilities
//
// Shared validation patterns and helpers for EditorCore.
//
// Note: These use simple regex validation rather than CoreUtils typia validators because:
// 1. These are format checks (identifier patterns), not data boundary validations
// 2. The input is already a known string type, not unknown external data
// 3. Typia validators are designed for parsing/validating complex structured data,
//    not simple format patterns like "starts with letter, alphanumeric only"
//

// Pin name validation: must start with a letter, contain only alphanumeric and underscore.
export const PIN_NAME_PATTERN = /^[a-zA-Z][a-zA-Z0-9_]*$/;

export function isValidPinName(name: string): boolean {
  return PIN_NAME_PATTERN.test(name);
}
